import _styled from "styled-components";
import { ArrowDownTrayIcon, BanknotesIcon, BuildingOfficeIcon, CalendarIcon, CircleStackIcon, CreditCardIcon, FaceSmileIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { Badge } from '@restworld/ui-ds-base';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import IconButton from '../icon-button';
import Title from '../title';
import { ButtonV2 } from '../button-v2';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerInvoiceCard(_ref) {
  var invoiceNumber = _ref.invoiceNumber,
      companyName = _ref.companyName,
      issueDate = _ref.issueDate,
      slots = _ref.slots,
      discount = _ref.discount,
      amount = _ref.amount,
      status = _ref.status,
      statusText = _ref.statusText,
      onDownloadInvoice = _ref.onDownloadInvoice,
      isAnnualSubscription = _ref.isAnnualSubscription,
      discountType = _ref.discountType,
      downloadInvoicePending = _ref.downloadInvoicePending,
      hostedInvoiceUrl = _ref.hostedInvoiceUrl,
      onPayInvoice = _ref.onPayInvoice,
      isPpu = _ref.isPpu;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useTranslation2 = useTranslation('payment-and-invoices'),
      tPayment = _useTranslation2.t;

  var cardActions = /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!statusText && /*#__PURE__*/_jsx(StatusBadge, {
      variant: status === 'paid' ? 'success' : status === 'to_be_paid' ? 'danger' : 'warning',
      children: statusText
    }), !!onDownloadInvoice && /*#__PURE__*/_jsx(IconButton, {
      onClick: onDownloadInvoice,
      Icon: ArrowDownTrayIcon,
      variant: "neutral",
      ariaLabel: "download-invoice",
      loading: downloadInvoicePending
    }), !!hostedInvoiceUrl && !!onPayInvoice && /*#__PURE__*/_jsx(ButtonV2, {
      variant: "secondary-danger",
      StartIcon: CreditCardIcon,
      onClick: onPayInvoice,
      children: tPayment('pay')
    })]
  });

  return /*#__PURE__*/_jsx(CardContainer, {
    children: /*#__PURE__*/_jsxs(CardContent, {
      children: [/*#__PURE__*/_jsx(_StyledCardActions, {
        children: cardActions
      }), /*#__PURE__*/_jsx(InvoiceNumber, {
        invoiceNumber: invoiceNumber
      }), /*#__PURE__*/_jsxs(_StyledDiv, {
        children: [/*#__PURE__*/_jsxs(InfoItemsContainer, {
          children: [!!companyName && /*#__PURE__*/_jsx(InfoItem, {
            icon: BuildingOfficeIcon,
            text: companyName
          }), !!issueDate && /*#__PURE__*/_jsx(InfoItem, {
            icon: CalendarIcon,
            text: issueDate
          }), !!slots && /*#__PURE__*/_jsx(InfoItem, {
            icon: CircleStackIcon,
            text: isPpu ? "".concat(slots, " ").concat(slots > 1 ? t('days_key') : t('day_key')) : "".concat(slots, " ").concat(slots > 1 ? 'slots' : 'slot'),
            isAnnualSubscription: isAnnualSubscription
          }), !!discount && /*#__PURE__*/_jsx(InfoItem, {
            icon: FaceSmileIcon,
            text: "".concat(t('discount'), ": ").concat(discount).concat(discountType === 'percentage' ? '%' : '€')
          }), /*#__PURE__*/_jsx(InfoItem, {
            icon: BanknotesIcon,
            text: "".concat(amount, "\u20AC")
          })]
        }), /*#__PURE__*/_jsx(_StyledCardActions2, {
          children: cardActions
        })]
      })]
    })
  });
}

var InfoItem = function InfoItem(_ref2) {
  var Icon = _ref2.icon,
      text = _ref2.text,
      isAnnualSubscription = _ref2.isAnnualSubscription;

  var _useTranslation3 = useTranslation('common'),
      t = _useTranslation3.t;

  return /*#__PURE__*/_jsxs(InfoItemContainer, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(Icon, {})
    }), /*#__PURE__*/_jsx(InfoText, {
      children: isAnnualSubscription ? t('annual_subscription') : text
    })]
  });
};

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__CardContainer",
  componentId: "sc-143949y-0"
})({
  "display": "inline-flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1.5rem",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "--tw-shadow": "0px 2px 4px 0px rgba(0,0,26,0.05)",
  "--tw-shadow-colored": "0px 2px 4px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var CardContent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__CardContent",
  componentId: "sc-143949y-1"
})({
  "display": "inline-flex",
  "flexShrink": "1",
  "flexGrow": "1",
  "flexBasis": "0px",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.5rem",
  "@media (min-width: 1024px)": {
    "gap": "0px"
  }
});

var InvoiceNumber = /*#__PURE__*/_styled(function (_ref3) {
  var invoiceNumber = _ref3.invoiceNumber;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isMobile = _useResponsiveBreakPo.isMobile,
      isTablet = _useResponsiveBreakPo.isTablet;

  return /*#__PURE__*/_jsx(Title, {
    maxChars: isMobile ? 25 : isTablet ? 50 : 100,
    textColor: "neutral-700",
    fontSize: "base",
    fontWeight: "semibold",
    content: invoiceNumber === null || invoiceNumber === void 0 ? void 0 : invoiceNumber.toString()
  });
}).withConfig({
  displayName: "employer-invoice-card__InvoiceNumber",
  componentId: "sc-143949y-2"
})(["", ""], {
  "alignSelf": "stretch"
});

var InfoItemsContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__InfoItemsContainer",
  componentId: "sc-143949y-3"
})({
  "display": "inline-flex",
  "flexWrap": "wrap",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "rowGap": "0.5rem",
  "columnGap": "1.25rem",
  "alignSelf": "stretch"
});

var CardActions = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__CardActions",
  componentId: "sc-143949y-4"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "@media (min-width: 1024px)": {
    "width": "fit-content",
    "justifyContent": "flex-end",
    "gap": "0.75rem"
  }
});

var _StyledCardActions2 = /*#__PURE__*/_styled(CardActions).withConfig({
  displayName: "employer-invoice-card___StyledCardActions2",
  componentId: "sc-143949y-5"
})({
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "flex"
  }
});

var _StyledCardActions = /*#__PURE__*/_styled(CardActions).withConfig({
  displayName: "employer-invoice-card___StyledCardActions",
  componentId: "sc-143949y-6"
})({
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});

var StatusBadge = /*#__PURE__*/_styled(Badge).withConfig({
  displayName: "employer-invoice-card__StatusBadge",
  componentId: "sc-143949y-7"
})(["", ""], {
  "alignSelf": "flex-start",
  "borderRadius": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.125rem",
  "paddingBottom": "0.125rem",
  "@media (min-width: 768px)": {
    "alignSelf": "center"
  }
});

var InfoItemContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__InfoItemContainer",
  componentId: "sc-143949y-8"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.125rem"
});

var IconWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__IconWrapper",
  componentId: "sc-143949y-9"
})({
  "position": "relative",
  "height": "1rem",
  "width": "1rem"
});

var InfoText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-invoice-card__InfoText",
  componentId: "sc-143949y-10"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

export default EmployerInvoiceCard;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "employer-invoice-card___StyledDiv",
  componentId: "sc-143949y-11"
})({
  "@media (min-width: 1024px)": {
    "display": "flex",
    "width": "100%",
    "alignItems": "center",
    "justifyContent": "space-between"
  }
});